import { cx } from 'styled-system/css';
import { matchStyles } from '../match.style';
import { matchOutrightStyles } from './match-outright.style';
import { OutrightMarket, SportMatchModel } from '@nf/types/odds';
import { getTeamName } from '@/utils/odds-utils';
import { OddsButton } from '@/components/widgets/odds-button';
import { useOddsTableMarsContext } from '@/features/odds-table-mars/context';

export interface MatchOutrightProps {
	match: SportMatchModel;
	markets: OutrightMarket[];
	teamNameMap?: Map<number, string>;
}

export const MatchOutright = ({
	match,
	markets,
	teamNameMap
}: MatchOutrightProps) => {
	const { oddsType, actStatus } = useOddsTableMarsContext();
	return (
		<div className={cx('match', matchStyles.match)}>
			<div className={matchOutrightStyles.teams}>
				{
					markets.sort((a, b) => {
						// sort by odds & team name (不可使用 localeCompare, 因中英文混雜排序會不如預期)
						let compare = a.Price - b.Price;
						if (compare === 0) {
							const teamNameA = getTeamName(a.TeamId, teamNameMap);
							const teamNameB = getTeamName(b.TeamId, teamNameMap);
							if (teamNameA > teamNameB) {
								compare = 1;
							} else if (teamNameA < teamNameB) {
								compare = -1;
							}
						}
						return compare;
					}).map(market => (
						<div
							key={`outright_content${market.MarketId}`}
							className={matchOutrightStyles.team}
						>
							<div className={cx(matchOutrightStyles.teamName)}>{getTeamName(market.TeamId, teamNameMap)}</div>
							<OddsButton
								key={market.MarketId}
								match={match}
								market={market}
								homeTeamName={''}
								awayTeamName={''}
								betTeam={''}
								originalPrice={market.Price}
								type="OT"
								sport={999}
								oddsType={oddsType}
								accountStatus={actStatus ?? 0}
							/>
						</div>
					))
				}
			</div>
		</div>
	);
};
